import { render, staticRenderFns } from "./ApplyMaterialMapping.vue?vue&type=template&id=2ec12098&scoped=true&"
import script from "./ApplyMaterialMapping.vue?vue&type=script&lang=js&"
export * from "./ApplyMaterialMapping.vue?vue&type=script&lang=js&"
import style0 from "./ApplyMaterialMapping.vue?vue&type=style&index=0&id=2ec12098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec12098",
  null
  
)

export default component.exports